<div class="left" (click)="goToCenter()">
  <span>{{ "about_me" | translate }}</span>
  <i class="fas fa-chevron-left"></i>
</div>
<div class="row d-flex justify-content-center">
  <h1 class="text-center">{{ "galery" | translate }}</h1>

  <div class="col-12 mt-5">
    <div class="carousel-coantiner">
      <carousel [isAnimated]="true" [showIndicators]="false" [interval]="10000">
        <slide *ngFor="let item of galleryList; let index = index">
          <div
            class="container-image"
            *ngIf="typeService(item.urlFile) === 'image'"
          >
            <img [src]="buildUrlGallery(item)" class="image-gallery" />
          </div>

          <div
            class="container-video"
            *ngIf="typeService(item.urlFile) === 'video'"
          >
            <video class="d-block w-100" controls style="background: black">
              <source [src]="buildUrlGallery(item)" type="video/mp4" />
            </video>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</div>
<div class="row mt-5">
  <div class="col-12 text-center">
    <h1>{{ "services" | translate }}</h1>
    <!--<div class="servicios">
        <div class="servicio">
          <img
            src="https://tarjetasf.virtualplace.online/fotosPortada/114/11262021103637AM114_B.jpg?nocache=0.6211728250716673"
          />
          <div class="servicio-detalles">
            <h3>Titulo</h3>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Animi,
              similique!
            </p>
          </div>
        </div>
        <div class="servicio">
          <img
            src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/4273/sophie.jpg"
          />
          <div class="servicio-detalles">
            <h3>Titulo</h3>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Animi,
              similique!
            </p>
          </div>
        </div>
      </div> -->

    <div class="services" *ngFor="let item of servicesList; let index = index">
      <a target="_blank" [href]="urlService(index)">
        <div class="box">
          <p
            [ngClass]="{
              'span-image': !typeServiceImage(imageService(index))
            }"
          >
            {{ item.nombreServicio }}
          </p>
          <img
            [src]="imageService(index)"
            [ngClass]="{
              svg: typeServiceImage(imageService(index)),
              'image-service': !typeServiceImage(imageService(index))
            }"
          />
        </div>
      </a>
    </div>
  </div>
</div>
